export default __webpack_public_path__ + "static/media/markerPoint-mask.af85fd43.svg";